export enum ButtonIconStatus {
  Before = 'before',
  After = 'after'
}
